<!-- Version inline (mobile) -->
<div *ngIf="inline" class="wizard-list-inline" [class.theme-dark]="theme === 'dark'">
    <!-- Header mobile avec bouton retour -->
    <div class="wizard-inline-header">
        <button class="btn-back" (click)="close.emit()">
            <i class="fa fa-arrow-left"></i>
        </button>
        <h6>Guides interactifs</h6>
    </div>

    <!-- Liste des wizards -->
    <div class="wizard-item-inline" *ngFor="let wizard of availableWizards" [class.completed]="wizard.hasBeenSeen">
        <!-- Checkbox indépendante -->
        <div class="wizard-checkbox-inline" [class.is-loading]="isTogglingWizard"
            (click)="toggleWizardStatus($event, wizard.id)">
            <label class="form-checkbox">
                <input type="checkbox" [checked]="wizard.hasBeenSeen">
                <span class="form-icon">
                    <svg class="checkmark" viewBox="0 0 24 24">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                    </svg>
                </span>
            </label>
        </div>

        <!-- Zone cliquable pour lancer le wizard -->
        <div class="wizard-content-inline" (click)="startWizard(wizard.id)">
            <strong>{{ wizard.label }}</strong>
            <p>{{ wizard.description }}</p>
        </div>

        <i class="fa fa-angle-right" (click)="startWizard(wizard.id)"></i>
    </div>

    <!-- Bouton reset -->
    <button class="btn-reset-inline" (click)="resetAllWizards()">
        <i class="fa fa-redo-alt"></i>
        Réinitialiser tous les guides
    </button>
</div>

<!-- Version modal (desktop) - réutilise le HTML existant -->
<div *ngIf="!inline" class="wizard-modal-content">
    <!-- Body avec liste de wizards -->
    <div class="wizard-modal-body">
        <div class="wizard-item" *ngFor="let wizard of availableWizards" [class.completed]="wizard.hasBeenSeen">

            <!-- Checkbox indépendante -->
            <div class="wizard-item-checkbox" [class.is-loading]="isTogglingWizard"
                (click)="toggleWizardStatus($event, wizard.id)">
                <label class="form-checkbox">
                    <input type="checkbox" [checked]="wizard.hasBeenSeen">
                    <span class="form-icon">
                        <svg class="checkmark" viewBox="0 0 24 24">
                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                        </svg>
                    </span>
                </label>
            </div>

            <!-- Zone cliquable pour lancer le wizard -->
            <div class="wizard-item-clickable" (click)="startWizard(wizard.id)">
                <div class="wizard-item-content">
                    <h5 class="wizard-title">{{ wizard.label }}</h5>
                    <p class="wizard-description">{{ wizard.description }}</p>
                </div>
                <div class="wizard-item-action">
                    <div class="play-button">
                        <i class="fa fa-play"></i>
                    </div>
                </div>
            </div>
        </div>

        <!-- État vide -->
        <div class="wizard-empty" *ngIf="availableWizards.length === 0">
            <div class="empty-icon">
                <i class="fa fa-magic"></i>
            </div>
            <p>Aucun guide disponible pour le moment</p>
        </div>
    </div>

    <!-- Footer avec reset -->
    <div class="wizard-modal-footer">
        <button class="btn-reset" (click)="resetAllWizards()">
            <i class="fa fa-redo-alt"></i>
            <span>Réinitialiser tous les guides</span>
        </button>
    </div>
</div>